import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f8b3198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-white font-light text-xl text-left overflow-auto w-full" }
const _hoisted_2 = { class: "selector-nav flex flex-row content-center justify-between p-4 w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "YOUR TOKENS", -1))
const _hoisted_4 = { class: "flex items-center transition-all" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "inline mr-1",
  width: "10",
  height: "7",
  viewBox: "0 0 10 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    y1: "0.5",
    x2: "10",
    y2: "0.5",
    stroke: "white"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    y1: "3.5",
    x2: "10",
    y2: "3.5",
    stroke: "white"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    y1: "6.5",
    x2: "10",
    y2: "6.5",
    stroke: "white"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "26.7906",
    y1: "9.40166",
    x2: "9.4015",
    y2: "26.7908",
    stroke: "white",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "8.73274",
    y1: "8.65633",
    x2: "26.1218",
    y2: "26.0454",
    stroke: "white",
    "stroke-width": "2"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "selector-steps flex flex-row" }
const _hoisted_9 = { class: "selector-step p-4" }
const _hoisted_10 = {
  key: 0,
  class: "dot flex items-center bg-black flex-0 current",
  "aria-hidden": "true"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-2 border-white border-solid relative z-10 w-6 h-6 flex items-center justify-center bg-black border-2 border-white rounded-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h-1.5 w-1.5 bg-white rounded-full animate-ping background-black" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "dot flex items-center"
}
const _hoisted_14 = { class: "relative z-10 w-6 h-6 flex items-center justify-center bg-white rounded-full border-white border-solid border-2" }
const _hoisted_15 = {
  key: 2,
  class: "dot flex items-center",
  "aria-hidden": "true"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative z-10 w-6 h-6 flex items-center justify-center bg-black border-2 border-solid border-gray-500 rounded-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h-2.5 w-2.5 bg-transparent rounded-full" })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "flex flex-row justify-between px-4 my-4" }
const _hoisted_19 = {
  key: 0,
  class: "self-start text-xl"
}
const _hoisted_20 = {
  key: 1,
  class: "self-start text-xl"
}
const _hoisted_21 = {
  key: 2,
  class: "text-sm flex items-center mr-1"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "relative selection-grid grid grid-cols-2 md:grid-cols-4 gap-4 max-h-[400px] px-4" }
const _hoisted_24 = { class: "relative px-1 flex flex-col gap-1 flex-1 justify-end" }
const _hoisted_25 = {
  key: 0,
  class: "absolute top-1 left-1 text-xs rounded bg-black bg-opacity-50 px-2 py-1"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "absolute top-1 left-1 text-xs rounded bg-black bg-opacity-50 px-2 py-1" }
const _hoisted_28 = { class: "relative mt-3 px-1 text-left flex flex-col gap-1 flex-1 justify-end" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["disabled", "onClick"]
const _hoisted_33 = { class: "mx-2" }
const _hoisted_34 = ["disabled", "onClick"]
const _hoisted_35 = ["href"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.75 2.25H2.25C1.91848 2.25 1.60054 2.3817 1.36612 2.61612C1.1317 2.85054 1 3.16848 1 3.5V9.75C1 10.0815 1.1317 10.3995 1.36612 10.6339C1.60054 10.8683 1.91848 11 2.25 11H8.5C8.83152 11 9.14946 10.8683 9.38388 10.6339C9.6183 10.3995 9.75 10.0815 9.75 9.75V7.25M7.25 1H11M11 1V4.75M11 1L4.75 7.25",
    stroke: "white",
    "stroke-opacity": "0.50",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "selection-grid w-full grid grid-cols-1 gap-0 max-h-[400px] mt-4" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "flex gap-4 items-center" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "checkbox-inner" })
], -1))
const _hoisted_43 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_44 = { class: "block" }
const _hoisted_45 = { class: "block font-normal" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = { class: "mx-2" }
const _hoisted_49 = ["disabled", "onClick"]
const _hoisted_50 = ["href"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.75 2.25H2.25C1.91848 2.25 1.60054 2.3817 1.36612 2.61612C1.1317 2.85054 1 3.16848 1 3.5V9.75C1 10.0815 1.1317 10.3995 1.36612 10.6339C1.60054 10.8683 1.91848 11 2.25 11H8.5C8.83152 11 9.14946 10.8683 9.38388 10.6339C9.6183 10.3995 9.75 10.0815 9.75 9.75V7.25M7.25 1H11M11 1V4.75M11 1L4.75 7.25",
    stroke: "white",
    "stroke-opacity": "0.75",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { class: "w-full flex flex-row mt-4" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "19",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.66667 15L0.999998 8M0.999998 8L7.66667 1M0.999998 8L19 8",
    stroke: "white"
  })
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Back", -1))
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "19",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.3333 1L18 8M18 8L11.3333 15M18 8L0 8",
    stroke: "black"
  })
], -1))

import { EyeOffIcon } from '@heroicons/vue/solid';
import { DataClientNFT } from '@/common/constants';
import { useInjectTopLevelProps } from '@/exports/MBurnRedeemCompleteWidgetProps';
import {
  computed, ref, onMounted,
} from 'vue';
import MediaLoader from '@/components/MediaLoader.vue';
import { CheckIcon } from '@heroicons/vue/solid';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';
import Modal from '@/components/Modal.vue';
import { useBR } from '@/composables/useBR';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenSelectorDialog',
  props: {
    eligibleBurnTokens: null
  },
  emits: ['selectedTokens', 'checkout', 'close', 'next'],
  setup(__props: any, { emit }) {

const props = __props as {
  eligibleBurnTokens: DataClientNFT[][];
};

const { network: propsNetwork } = useInjectTopLevelProps();


const viewAsList = ref(false);
const steps = ref<{
  name: string;
  status: string;
  selectedTokens: DataClientNFT[]
}[]>([{
  name: '',
  status: '',
  selectedTokens: [],
}]);

const { burn } = useBR();

const numberToRedeem = computed(() => {
  let amount = 0;

  if (!burn.value || !steps.value[0].selectedTokens.length) {
    return amount;
  }


  let divisor = burn.value.burnSet[0].items[0].amount.toNumber();
  divisor = divisor === 0 ? 1 : divisor;

  // we can just inspect the first step/group since they should all align
  for (let i = 0; i < steps.value[0].selectedTokens.length; i++) {
    amount +=  parseInt(steps.value[0].selectedTokens[i].count) / divisor;
  }

  return amount;
});

const currentStepIndex = computed(() => {
  return steps.value.findIndex((step) => step.status === 'current');
});

const currentStepIsSatisfied = computed(() => {
  if (!steps.value[currentStepIndex.value]?.selectedTokens) {
    return false;
  }

  if (currentStepIndex.value === 0) {
    // if this step is an 1155 step it is only valid if there is 1 token selected
    if (props.eligibleBurnTokens[currentStepIndex.value][0].spec === 'erc1155') {
      return steps.value[currentStepIndex.value]?.selectedTokens.length === 1;
    } else {
      return steps.value[currentStepIndex.value]?.selectedTokens.length >= 1;
    }
  }

  // add up the number of tokens selected in this step by adding up their `count` and then compare it to the number to redeem
  let numberToCompare = 0;
  for (let i = 0; i < steps.value[currentStepIndex.value].selectedTokens.length; i++) {
    if (steps.value[currentStepIndex.value].selectedTokens[i].spec === 'erc1155') {
      numberToCompare += parseInt(steps.value[currentStepIndex.value].selectedTokens[i].count);
    } else {
      numberToCompare += 1;
    }
  }

  let amountMultiplier = burn.value?.burnSet[currentStepIndex.value].items[0].amount.toNumber();
  if (!amountMultiplier || amountMultiplier === 0) {
    amountMultiplier = 1;
  }

  return numberToCompare === numberToRedeem.value * amountMultiplier;
});

onMounted(() => {
  let theSteps = [];
  const stepsLength = burn.value?.burnSet.length || 0;
  for (let i = 0; i < stepsLength; i++) {
    theSteps.push({
      name: `Token ${i+1} ${burn.value?.burnSet[i].items[0].tokenSpec === 1 ? '(ERC721)' : '(ERC1155)'}`,
      status: 'next',
      selectedTokens: [] as DataClientNFT[],
    });
  }

  theSteps[0].status = 'current';
  steps.value = theSteps;
  emit('selectedTokens', []);

  handleSelectToken(props.eligibleBurnTokens[0][0], 0);
});

const next = () => {
  if (currentStepIndex.value === steps.value.length - 1) {
    const allSelectedTokens = steps.value.reduce((acc, step) => {
      acc.push(step.selectedTokens);
      return acc;
    }, [] as DataClientNFT[][]);
    emit('selectedTokens', allSelectedTokens);
    emit('checkout');
  } else {
    for (let i = 0; i < steps.value.length; i++) {
      if (steps.value[i].status === 'current') {
        steps.value[i + 1].status = 'current';
        steps.value[i].status = 'complete';
        const activeStep = document.querySelector('.selector-steps .current');
        // scroll across the .selector-steps container to show the current step
        activeStep?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
        break;
      }
    }
  }
};

const previous = () => {
  for (let i = 0; i < steps.value.length; i++) {
    if (steps.value[i].status === 'current') {
      steps.value[i].selectedTokens = [];
      steps.value[i - 1].status = 'current';
      steps.value[i].status = 'next';
      break;
    }
  }
};

const close = () => {
  emit('close');
  for (let i = 0; i < steps.value.length; i++) {
    steps.value[i].selectedTokens = [];
  }
  emit('selectedTokens', []);
};

const eligibleTokenIsInSelectedTokens = (token: DataClientNFT, stepIdx: number) => {
  return steps.value[stepIdx].selectedTokens.some((tk: DataClientNFT) => {
    return twoTokensAreTheSame(tk, token);
  });
};

const twoTokensAreTheSame = (token1: DataClientNFT, token2: DataClientNFT) => {
  return token1.tokenId === token2.tokenId && token1.contractAddress === token2.contractAddress;
};

const tokenCanBeSelected = (token: DataClientNFT, idx: number) => {
  // @dev: if the token is already selected on a previous step, we should not allow it to be selected again
  for (let i = 0; i < idx; i ++) {
    if (steps.value[i]
      && steps.value[i].selectedTokens.findIndex((t) => {
        return twoTokensAreTheSame(t, token);
      }) > -1
    ) {
      return false;
    }
  }

  const equivalentEligibleToken = props.eligibleBurnTokens[idx].find((t) => {
    return twoTokensAreTheSame(t, token);
  });

  // @dev: if the amount the user owns is less than the amount they need to burn to redeem just one, we should not allow them to select it
  if (burn.value?.burnSet
    && token.spec === 'erc1155'
    && parseInt(equivalentEligibleToken?.count || '1') < burn.value.burnSet[idx].items[0].amount.toNumber()
  ) {
    return false;
  }

  // @dev: if the amount the user owns is less than the amount they need to burn to redeem the number they are redeeming from step 1, we should not allow them to select it
  if (burn.value?.burnSet
    && token.spec === 'erc1155'
    && parseInt(token.count) < burn.value.burnSet[idx].items[0].amount.mul(numberToRedeem.value).toNumber()
  ) {
    return false;
  }

  return true;
};

const handleDecreaseToken = (token: DataClientNFT, stepIdx: number) => {
  const theSelectedTokensSpot = steps.value[stepIdx].selectedTokens.findIndex((tk: DataClientNFT) => {
    return twoTokensAreTheSame(tk, token);
  });
  const stepAmount = burn.value?.burnSet[stepIdx].items[0].amount.toNumber() || 1;
  const theSelectedCount = parseInt(steps.value[stepIdx].selectedTokens[theSelectedTokensSpot].count);
  const theNewCount =  (theSelectedCount - stepAmount);

  if (theNewCount > 0) {
    steps.value[stepIdx].selectedTokens[theSelectedTokensSpot].count = theNewCount.toString();
  }
};

const handleIncreaseToken = (token: DataClientNFT, stepIdx: number, tokenIdx: number) => {
  const theSelectedTokensSpot = steps.value[stepIdx].selectedTokens.findIndex((tk: DataClientNFT) => {
    return twoTokensAreTheSame(tk, token);
  });
  const theOriginalToken = props.eligibleBurnTokens[stepIdx][tokenIdx];

  const stepAmount = burn.value?.burnSet[stepIdx].items[0].amount.toNumber() || 1;
  const theSelectedCount = parseInt(steps.value[stepIdx].selectedTokens[theSelectedTokensSpot].count);
  const theNewCount =  (theSelectedCount + stepAmount);

  if (!burn.value?.totalSupply && theNewCount <= parseInt(theOriginalToken.count)) {
    steps.value[stepIdx].selectedTokens[theSelectedTokensSpot].count = theNewCount.toString();
  } else if (burn.value?.totalSupply
    && theNewCount <= parseInt(theOriginalToken.count)
    && (theNewCount / stepAmount) <= (burn.value.totalSupply - burn.value.redeemedCount)
  ) {
    steps.value[stepIdx].selectedTokens[theSelectedTokensSpot].count = theNewCount.toString();
  }
};

const handleSelectToken = (token: DataClientNFT, stepIdx: number) => {
  if (!burn.value) {
    throw new Error('Cannot select tokens with no burn information, contact support');
  }

  const theSelectedTokensSpot = steps.value[stepIdx].selectedTokens.findIndex((tk: DataClientNFT) => {
    return twoTokensAreTheSame(tk, token);
  });

  if (currentStepIndex.value === 0) {
    if (theSelectedTokensSpot >= 0) {
      // remove the clicked on token from selectedTokens, they're deselecting it
      steps.value[stepIdx].selectedTokens.splice(theSelectedTokensSpot, 1); // 2nd parameter means remove one item only
    } else {
      // add the token to selected tokens array for that step
      let burnAmount = burn.value.burnSet[stepIdx].items[0].amount.toString();
      burnAmount = burnAmount === '0' ? '1' : burnAmount;
      const newToken = {
        ...token,
        count: burnAmount,
      };

      // @dev: multiselect is fine on erc721, but not erc1155
      if (token.spec === 'erc721') {
        steps.value[stepIdx].selectedTokens.push(newToken);

        // dont allow them to select more than what is in the supply
        if (burn.value.totalSupply) {
          if (steps.value[stepIdx].selectedTokens.length > (burn.value.totalSupply - burn.value.redeemedCount)) {
            steps.value[stepIdx].selectedTokens.shift();
          }
        }

      } else {
        steps.value[stepIdx].selectedTokens = [newToken];
      }
    }
  } else {
    if (theSelectedTokensSpot >= 0) {
      // remove the clicked on token from selectedTokens, they're deselecting it
      steps.value[stepIdx].selectedTokens.splice(theSelectedTokensSpot, 1); // 2nd parameter means remove one item only
    } else {
      if (token.spec === 'erc721') {
        const newToken = {
          ...token,
          count: '1',
        };
        // @dev: multiselect support -- add, then remove the first element if too many have been selected
        steps.value[stepIdx].selectedTokens.push(newToken);
        if (steps.value[stepIdx].selectedTokens.length > numberToRedeem.value) {
          steps.value[stepIdx].selectedTokens.shift();
        }
      } else {
        // @dev: multiselect is fine on erc721, but not erc1155
        // @dev: add to the steps selctedTokens in the exact amount required
        const newToken = {
          ...token,
          count: burn.value?.burnSet[stepIdx].items[0].amount.mul(numberToRedeem.value).toString() || '1',
        };
        steps.value[stepIdx].selectedTokens = [newToken];
      }
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", {
              class: "text-sm flex items-center transition-all cursor-pointer hover:opacity-80",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (viewAsList.value = !viewAsList.value))
            }, [
              _hoisted_5,
              _createTextVNode(" VIEW AS A " + _toDisplayString(viewAsList.value ? 'GRID' : 'LIST'), 1)
            ]),
            _createElementVNode("span", {
              class: "transition-all cursor-pointer hover:opacity-80 ml-2",
              onClick: close
            }, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, stepIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "selector-step-container w-full",
              key: stepIdx
            }, [
              _createElementVNode("div", _hoisted_9, [
                (step.status === 'current')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_12))
                  : (step.status === 'complete')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, [
                          _createVNode(_unref(CheckIcon), {
                            class: "w-5 h-5 text-black",
                            "aria-hidden": "true"
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17)),
                _createTextVNode(" " + _toDisplayString(step.name), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_unref(numberToRedeem) > 0 && _unref(currentStepIndex) > 0 && _unref(burn)?.burnSet[_unref(currentStepIndex)].items[0].tokenSpec === 1)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_19, " SELECT " + _toDisplayString(_unref(numberToRedeem)) + " TOKEN" + _toDisplayString(_unref(numberToRedeem) > 1 ? 'S' : '') + " TO BURN ", 1))
            : (_openBlock(), _createElementBlock("h1", _hoisted_20, " SELECT TOKENS ")),
          (_unref(numberToRedeem))
            ? (_openBlock(), _createElementBlock("h2", _hoisted_21, " [REDEEMING " + _toDisplayString(_unref(numberToRedeem)) + "] ", 1))
            : _createCommentVNode("", true)
        ]),
        (!viewAsList.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_unref(Carousel), {
                "items-to-show": 1,
                "items-to-scroll": 1,
                "model-value": _unref(currentStepIndex),
                class: "w-full",
                "wrap-around": false,
                "mouse-drag": false,
                "touch-drag": false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
                    return (_openBlock(), _createBlock(_unref(Slide), {
                      key: step.name
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.eligibleBurnTokens[index], (token, tidx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: token.name,
                              class: _normalizeClass(["eligible-token-card", {
                    disabled: !tokenCanBeSelected(token, index),
                    active: step.selectedTokens[0] && eligibleTokenIsInSelectedTokens(token, index)
                  }])
                            }, [
                              _createElementVNode("div", _hoisted_24, [
                                (token.image)
                                  ? (_openBlock(), _createBlock(MediaLoader, {
                                      key: 0,
                                      media: token.image,
                                      onClick: ($event: any) => (handleSelectToken(token, index))
                                    }, {
                                      injector: _withCtx(() => [
                                        (token.spec === 'erc1155')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, " x " + _toDisplayString(token.count || '1'), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["media", "onClick"]))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      onClick: ($event: any) => (handleSelectToken(token, index)),
                                      class: "h-full flex items-center justify-center m-lazy-media"
                                    }, [
                                      _createVNode(_unref(EyeOffIcon), { class: "h-8 w-8 m-auto" }),
                                      _createElementVNode("span", _hoisted_27, " x " + _toDisplayString(token.count || '1'), 1)
                                    ], 8, _hoisted_26)),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("h2", {
                                    onClick: ($event: any) => (handleSelectToken(token, index))
                                  }, _toDisplayString(token.name || 'Name Not Found'), 9, _hoisted_29),
                                  _createElementVNode("h4", {
                                    onClick: ($event: any) => (handleSelectToken(token, index))
                                  }, " Token #" + _toDisplayString(token.tokenId), 9, _hoisted_30),
                                  (token.spec === 'erc1155')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["flex flex-row items-center mt-1 amount-selector", {
                            disabled: !eligibleTokenIsInSelectedTokens(token, index)
                          }])
                                        }, [
                                          _createElementVNode("button", {
                                            class: "decrease",
                                            disabled: _unref(currentStepIndex) !== 0,
                                            onClick: ($event: any) => (handleDecreaseToken(token, index))
                                          }, " - ", 8, _hoisted_32),
                                          _createElementVNode("span", _hoisted_33, _toDisplayString(eligibleTokenIsInSelectedTokens(token, index)
                              ? step.selectedTokens[0].count
                              : '0'), 1),
                                          _createElementVNode("button", {
                                            class: "increase",
                                            disabled: _unref(currentStepIndex) !== 0 || (step.selectedTokens[0] && step.selectedTokens[0].count === token.count),
                                            onClick: ($event: any) => (handleIncreaseToken(token, index, tidx))
                                          }, " + ", 8, _hoisted_34)
                                        ], 2)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("a", {
                                    target: "_blank",
                                    class: "absolute bottom-1 right-1",
                                    href: `https://${_unref(propsNetwork) === 5 ? 'testnets.' : ''}opensea.io/assets/${
                          _unref(propsNetwork) === 5 ? 'goerli' : 'ethereum'
                        }/${token.contractAddress}/${token.tokenId}`
                                  }, _hoisted_37, 8, _hoisted_35)
                                ])
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model-value"])
            ]))
          : _createCommentVNode("", true),
        (viewAsList.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createVNode(_unref(Carousel), {
                "items-to-show": 1,
                "items-to-scroll": 1,
                "model-value": _unref(currentStepIndex),
                class: "w-full",
                "wrap-around": false,
                "mouse-drag": true,
                "touch-drag": false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
                    return (_openBlock(), _createBlock(_unref(Slide), {
                      key: step.name
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.eligibleBurnTokens[index], (token, tidx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: token.name,
                              class: _normalizeClass(["eligible-token-li relative pr-10", {
                    disabled: !tokenCanBeSelected(token, index),
                    active: step.selectedTokens[0] && eligibleTokenIsInSelectedTokens(token, index)
                  }]),
                              onClick: _withModifiers(($event: any) => (handleSelectToken(token, index)), ["stop"])
                            }, [
                              _createElementVNode("div", _hoisted_41, [
                                _hoisted_42,
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("h2", _hoisted_44, _toDisplayString(token.name || 'Name Not Found'), 1),
                                  _createElementVNode("h2", _hoisted_45, " TOKEN #" + _toDisplayString(token.tokenId), 1)
                                ])
                              ]),
                              (token.spec === 'erc1155')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["flex flex-row items-center ml-3 amount-selector", {
                        disabled: !eligibleTokenIsInSelectedTokens(token, index)
                      }])
                                    }, [
                                      _createElementVNode("button", {
                                        class: "decrease",
                                        disabled: _unref(currentStepIndex) !== 0,
                                        onClick: _withModifiers(($event: any) => (handleDecreaseToken(token, index)), ["stop"])
                                      }, " - ", 8, _hoisted_47),
                                      _createElementVNode("span", _hoisted_48, _toDisplayString(eligibleTokenIsInSelectedTokens(token, index)
                          ? step.selectedTokens[0].count
                          : '0'), 1),
                                      _createElementVNode("button", {
                                        class: "increase",
                                        disabled: _unref(currentStepIndex) !== 0 || (step.selectedTokens[0] && step.selectedTokens[0].count === token.count),
                                        onClick: _withModifiers(($event: any) => (handleIncreaseToken(token, index, tidx)), ["stop"])
                                      }, " + ", 8, _hoisted_49)
                                    ], 2)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("a", {
                                class: "absolute my-auto top-0 bottom-0 right-4 h-3",
                                target: "_blank",
                                href: `https://${_unref(propsNetwork) === 5 ? 'testnets.' : 'www.'}opensea.io/assets/${
                      _unref(propsNetwork) === 5 ? 'goerli' : 'ethereum'
                    }/${token.contractAddress}/${token.tokenId}`
                              }, _hoisted_52, 8, _hoisted_50)
                            ], 10, _hoisted_40))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model-value"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_53, [
          (_unref(currentStepIndex) !== 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "hover:border-white",
                onClick: previous
              }, _hoisted_56))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "bg-white text-black bg-lfg",
            disabled: !_unref(currentStepIsSatisfied),
            onClick: next
          }, [
            (_unref(currentStepIndex) !== steps.value.length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_58, " Select Next Burn Token "))
              : (_openBlock(), _createElementBlock("span", _hoisted_59, "Checkout")),
            _hoisted_60
          ], 8, _hoisted_57)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})